import * as React from 'react';
import { FlexCol } from '@client/components/FlexCol';
import { Typography } from '@mui/material';

export const QuestsPage = () => {
  return <FlexCol>
    <Typography variant={'h1'}>QuestsPage</Typography>
  </FlexCol>
}